
import { IInvoice } from '@/types/models';
import { defineComponent, PropType } from 'vue';

const $statusInvoiceDefault = 'Default';
const $statusInvoiceDelivered = 'Delivered';
const $statusInvoiceCancellation = 'Cancellation';

export default defineComponent({
  props: {
    invoice: {
      type: Object as PropType<IInvoice>,
      required: true,
    },
  },
  methods: {
    getInvoiceStatus(status: string) {
      if (status === $statusInvoiceDefault) {
        return '待开发票';
      }
      if (status === $statusInvoiceDelivered) {
        return '已开发票';
      }
      if (status === $statusInvoiceCancellation) {
        return '作废发票';
      }
      return '待开发票';
    },
  },
});
